<script setup lang='ts'>
import { computed } from 'vue'
import AppMenuItem from './AppMenuItem.vue'
import { useNavigationMenu } from '~/composables/navigation'
const { layoutState } = useLayout()

const { navigationMenu } = useNavigationMenu()
const model = navigationMenu() as Array<Record<string, any>>
const infoApp = appConfig.infoapp

const isMenuExpanded = computed(() => {
  if (layoutState.staticMenuMobileActive.value || layoutState.overlayMenuActive.value) {
    return true
  }

  return !layoutState.staticMenuDesktopInactive.value
})

const isMenuCompact = computed(() => !isMenuExpanded.value)
</script>

<template>
  <client-only>
    <ul class="layout-menu" :class="{ 'menu-compact': isMenuCompact }">
      <template v-for="(item, i) in model" :key="item">
        <app-menu-item v-if="!item.separator" :item="item" :index="i" :compact="isMenuCompact" />
        <li v-if="item.separator" class="menu-separator" />
      </template>
    </ul>
    <div v-if="!isMenuCompact" class="text-3 text-gray-500 " style="bottom: 0; position: absolute; width: 100%; text-align: left;">
      {{ `${infoApp.version} - ${infoApp.datebuild}` }}
    </div>
  </client-only>
</template>

<style lang="scss" scoped>
.menu-compact {
  .layout-menuitem-text {
    display: none !important;
  }

  .layout-submenu-toggler {
    display: none !important;
  }

  .layout-root-menuitem > .layout-menuitem-root-text {
    display: none !important;
  }
}
</style>
